// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608270204/js/" + chunkId + "." + {"44":"5719cd7c","225":"cfdbf252","481":"6c44c4ae","486":"139c1d24","770":"51c4d3c4"}[chunkId] + ".0.7744488224445503.chunk.js";
};